import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  storesRequest: ['sellerId', 'cep', 'isChangeQuantity'],
  storesSuccess: ['data', 'productId', 'cep', 'initialStore', 'sellerId'],
  storesFailed: ['error'],

  thirdRequest: [],
  thirdSuccess: ['data'],
  thirdFailed: ['error'],

  selectStore: ['store'],
});

const INITIAL_STATE = Immutable({
  cep: {},
  error: {},
  isLoading: false,
  pickUpStores: {},
  selectedStore: {},
  stores: [],
  thirdError: {},
  thirds: [],
});

const request = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const storesSuccess = (state = INITIAL_STATE, { data, productId = null, cep = null, initialStore, sellerId }) =>
  state
    .merge(sellerId ? { pickUpStores: state.getIn(['pickUpStores']).set(sellerId, data) } : { stores: data })
    .merge({
      isLoading: false,
      productId,
      selectedStore: initialStore ? data[0] || {} : state.getIn(['selectedStore']),
    })
    .merge({ cep: { [sellerId]: cep } }, { deep: true });

const storesFailed = (state = INITIAL_STATE, { error }) => state.merge({ isLoading: false, error });

const selectStore = (state = INITIAL_STATE, { store }) => state.set('selectedStore', store);

const thirdSucess = (state = INITIAL_STATE, { data }) => state.set('third', data);

const thirdError = (state = INITIAL_STATE, { error }) => state.set('thirdError', error);

export default createReducer(INITIAL_STATE, {
  [Types.STORES_REQUEST]: request,
  [Types.STORES_FAILED]: storesFailed,
  [Types.STORES_SUCCESS]: storesSuccess,

  [Types.SELECT_STORE]: selectStore,

  [Types.THIRD_SUCCESS]: thirdSucess,
  [Types.THIRD_FAILED]: thirdError,
});
